<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h2>
          메뉴 작성
        </h2>
        <p class="gray">메뉴를 작성합니다.</p>
      </div>
    </div>

    <el-form :model="frm" :rules="rules" ref="frm" label-width="120px" class="demo-form">
      <div class="card-body gray">
        <div class="card-form textarea">
          <el-form-item label="상위 메뉴" prop="parent_code">
            <el-select v-model="frm.parent_code" placeholder="상위메뉴를 선택하세요.">
              <el-option v-for="parent in parentSeqData" :label="parent.menu_name" :value="parent.menu_code" :key="parent.menu_code"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="메뉴 유형" prop="menu_type">
            <el-select v-model="form.menu_type" placeholder="메뉴 유형을 선택하세요.">
              <el-option label="메뉴" value="M"></el-option>
              <el-option label="화면" value="V"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="메뉴 코드" prop="menu_code">
            <el-input v-model.trim="frm.menu_code"></el-input>
          </el-form-item>
          <el-form-item label="메뉴명" prop="menu_name">
            <el-input v-model.trim="frm.menu_name"></el-input>
          </el-form-item>
          <el-form-item label="Link명" prop="menu_link">
            <el-input v-model.trim="frm.menu_link"></el-input>
          </el-form-item>
          <el-form-item label="Class명" prop="class_name">
            <el-input v-model.trim="frm.class_name"></el-input>
          </el-form-item>
          <el-form-item label="정렬순서" prop="ordby">
            <el-input-number v-model="frm.ordby" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item label="사용여부">
            <el-switch v-model="isUse" active-text="" inactive-text=""></el-switch>
          </el-form-item>
        </div>
      </div>
      <div class="card-body text-right">
        <el-button @click="resetForm('frm')">취소</el-button>
        <el-button type="primary" @click="submitForm('frm')">저장</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M990102',
  mixins: [common.mixins],
  data () {
    return {
      isUse: true,
      isModify: false,
      frm: {
        menu_code: '',
        menu_name: '',
        menu_type: '',
        menu_link: '',
        menu_icon: '',
        parent_code: '',
        ordby: 1,
        class_name: '',
        use_yn: 'Y'
      },
      parentSeqData: [],
      rules: {
        menu_code: [
          { required: true, message: '메뉴코드를 입력하십시오.', trigger: 'blur' },
          { min: 2, max: 20, message: '최소 2자 이상 입력하십시오.' }
        ],
        menu_name: [
          { required: true, message: '메뉴명을 입력하십시오.', trigger: 'blur' },
          { min: 2, max: 50, message: '최소 2자 이상 입력하십시오.' }
        ],
        parent_code: [
          { required: true, message: '상위 메뉴명을 선택하십시오.', trigger: 'change' }
        ]
      }
    }
  },
  beforeCreate () {
  },
  created () {
    common.axios.get('/menu/parent')
      .then(response => {
        this.parentSeqData = response.data
        // 조회
        const menuCode = this.$route.params.menu_code
        if (menuCode && menuCode !== '' && menuCode !== 'NEW') {
          this.isModify = true
          this.loadInfo(menuCode)
        }
      })
  },
  mounted () {
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const config = {
            url: this.isModify ? '/menu' : '/menu/storage',
            method: this.isModify ? 'put' : 'post',
            data: this.frm
          }
          common.axios.request(config)
            .then(response => {
              if (response.data.status === 1) {
                if (this.isModify) {
                  this.$message('수정하였습니다.')
                } else {
                  this.$message('등록하였습니다.')
                }
                setTimeout(() => {
                  this.$router.push({name: 'M990101', params: {isSearch: true}})
                }, 1000)
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    loadInfo (menuCode) {
      common.axios.get('/menu/load/' + menuCode)
        .then(response => {
          const result = response.data
          Object.keys(this.frm).forEach(key => {
            this.frm[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
          this.isUse = result.use_yn === 'Y'
        })
    }
  },
  watch: {
    isUse: function (value) {
      this.frm.use_yn = value ? 'Y' : 'N'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990102.vue